<template src="./activityFeedbackList.html"></template>
<script>
// import auth from '../../../Services/Firebase/auth'
// import state from '../../../Store/Modules/liveData'
import networkManager from '../../../NetworkManager/index'
// import v3 from '../../../NetworkManager/apiV3'
import { convertDate } from "../../../Services/Utils/DateTimeFormatter";
import showStatus from '../../../NetworkManager/showStatus'
import PortalFooter from '../../../Components/PortalFooter'

export default {
    name: 'activityFeedbackList',
    components: {
        PortalFooter
    },
    data() {
        return {
            search: "",
            loadTable: false,
            loading: false,
            isMobileView: false,
            userData: null,
            selectedInstitute: '',
            selectedSemester: '',
            headers: [
                {
                    text: 'Form Name',
                    align: 'left',
                    value: 'formTitle',
                    class: "DataTable"
                },
                {
                    text: 'Link',
                    align: 'left',
                    value: 'formURL'
                },
                {
                    text: "Type",
                    align: 'left',
                    value: 'formType'
                },
                {
                    text: 'Start Date',
                    align: 'left',
                    value: 'startDate'
                },
                {
                    text: 'End Date',
                    align: 'left',
                    value: 'endDate'
                }
                // {
                //     text: 'Status',
                //     align: 'left',
                //     value: 'submittedStatus'
                // }
            ],
            feedbackFormsList: [],
            pastFeedbackFormsList: [],
            submittedFormList: [],
            feedbackIds: []
        }
    },
    created() {
        // this.uId = this.$store.getters['user/get_userData'].uId
        this.selectedTopic = this.$store.getters['liveData/get_selectedTopic']

        this.$store.commit('liveData/set_selectedActivityName', 'Feedback Form')

        this.isMobileView = this.$store.getters['liveData/get_isMobileView']

        this.userData = this.$store.getters['user/get_userData']
        this.selectedInstitute = this.$store.getters[
            'instituteData/get_selectedInstitute'
        ]
        this.selectedSemester = this.$store.getters[
            'instituteData/get_selectedSemester'
        ]

        this.getStudentFillFormDetails();
    },
    methods: {
        openFeedbackForm(formURL) {
            if (!formURL) return;
            const fullURL = `https://feedbacks.studiumtech.in/${formURL}`;
            window.open(fullURL, '_blank');
        },
        activity() {
            this.$tours['activityFeedbackList'].start()
        },
        gotoFillFeedbackFormActivity(id) {
            if (this.isMobileView) {
                this.$router.push({
                    name: 'activityFillFeedbackForm2',
                    params: {
                        formId: id
                    }
                })
            } else {
                this.$router.push({
                    name: 'activityFillFeedbackForm',
                    params: {
                        formId: id
                    }
                })
            }
        },
        async getStudentFillFormDetails() {
            this.loadTable = true
            this.submittedFormList = []
            try {
                const res = await networkManager.getRequest('/feedbackWithNBAAttainment/getFeedbacksByUserId', {
                    userId: this.userData.uId
                })
                const data = await res.feedbacks
                console.log('data', data);
                data.map((item, index) => {
                    this.submittedFormList.push(item)
                })
                await this.getFormList()
                await this.getFormResponses()
                this.loadTable = false
            } catch (err) {
                showStatus(err, 6000, 'error', this)
                this.loadTable = false
            }
        },
        async getFormList() {
            this.feedbackFormsList = [];
            this.feedbackIds = []
            this.pastFeedbackFormsList = [];
            try {
                const res = await networkManager.getRequest(
                    '/feedbackWithNBAAttainment/getAllFeedbacksForStudentsWithoutDiv',
                    {
                        instituteId: this.selectedInstitute,
                        semId: this.userData.semId,
                        department: this.userData.department,
                        courseYear: this.userData.courseYear,
                        division: this.userData.division
                    }
                );

                if (!res?.feedbacks) {
                    throw new Error('No feedback data received');
                }

                const currentDate = new Date();
                const userSubjects = new Set(this.userData.subjects);
                res.feedbacks.forEach(item => {
                    this.feedbackIds.push(item.feedbackId)
                    const hasMatchingSubject = item.courses?.some(subject =>
                        userSubjects.has(subject.subjectId)
                    );

                    if (!hasMatchingSubject) return;

                    const submittedForm = this.submittedFormList.find(
                        s => s.feedbackFormId === item._id
                    );
                    const formData = {
                        ...item,
                        submittedOn: submittedForm ? convertDate(submittedForm.createdAt) : "-",
                        submittedStatus: !!submittedForm
                    };

                    const targetList = new Date(item.endDate) > currentDate
                        ? this.feedbackFormsList
                        : this.pastFeedbackFormsList;

                    if (!targetList.some(existing => existing._id === item._id)) {
                        targetList.push(formData);
                    }
                    this.feedbackFormsList = targetList
                });

            } catch (err) {
                console.error('Error fetching feedback forms:', err);
                showStatus(err.message || 'Failed to load feedback forms', 6000, 'error', this);
            }
        },
        async getFormResponses() {
            try {
                const res = await networkManager.getRequest('/feedbackResponse/getMultipleFeedbackResponsesByUId', {
                    uId: this.userData.uId,
                    feedbackFormIds: this.feedbackIds
                })
                if (res?.feedbacks?.length > 0) {
                    this.feedbackFormsList.forEach(feedback => {
                        res.feedbacks.forEach(response => {
                            if (feedback.feedbackId === response.feedbackFormId) feedback.submittedStatus = true
                        })
                    })
                }
            } catch (err) {
                showStatus(err, 6000, 'error', this)
            }
        }
    }
}
</script>
<style scoped src="./activityFeedbackList.css"></style>
